import { type ReactNode, useState } from 'react';
import { useWatch } from 'react-hook-form';
import type { EntityListValues } from '@/components/Entity/EntityList.types';
import * as EntityListCount from '@/components/Entity/EntityListCount';
import EntityListInput from '@/components/Entity/EntityListInput';
import Card from '@/components/UI/Card';
import Text from '@/components/UI/Text';
import Box from '@/components/Unistyles/Box';
import { MAXIMUM_PERSON_TEAM_COUNT } from '@/utils/constants';

export default function MemberAddList({ children }: { children?: ReactNode }) {
  const members = useWatch<EntityListValues>({ name: 'members' });
  const [menuIndex, setMenuIndex] = useState<number | null>(null);

  return (
    <Box direction="vertical" space="md" px="lg" pb="2xl">
      <Box direction="vertical" space="xs">
        <Text bold size="sm" variant="primary">
          OPTION 3
        </Text>
        <Text bold size="xl">
          Add people manually
        </Text>
        <Text variant="typographySecondary">
          Use this option to keep track of members that are not using 1Time
          Sports.
        </Text>
      </Box>
      <Card flex={1}>
        {children}
        <EntityListCount.Container>
          <EntityListCount.Heading name="members" />
          <EntityListCount.Input
            name="members"
            maxEntities={MAXIMUM_PERSON_TEAM_COUNT}
          />
        </EntityListCount.Container>
        {members.map((member, index) => (
          <EntityListInput
            key={member.id}
            name="members"
            index={index}
            isMenuOpen={menuIndex === index}
            setMenuIndex={setMenuIndex}
          />
        ))}
      </Card>
    </Box>
  );
}
